
var language = {
  // 中文
  1: {
    // 顶部内容
    top: {
      // 导航
      navs: [
        {path: "index",name: "首页"},
        {path: "product",name: "产品技术", other: {key: "MimicPro 2"},children: [
          {path: "product",name: "EDA", other: {key: "MimicPro 2"}, children: [
            {path: "product",name: "MimicTurbo GT", other: {key: "MimicTurbo GT"}},
            {path: "product",name: "MimicPro 2", other: {key: "MimicPro 2"}},
            {path: "product",name: "MimicPro 3", other: {key: "MimicPro 3"}},
          ]},
          {path: "product",name: "IP", other: {key: "USB"}, children: [
            {path: "product",name: "USB 控制器", other: {key: "USB"}},
            {path: "product",name: "PCle 控制器", other: {key: "PCle"}},
            {path: "product",name: "RDMA", other: {key: "RDMA"}}
          ]}
        ]},
        {path: "service",name: "支持与服务",children: []},
        {path: "news",name: "新闻中心",children: []},
        {path: "about",name: "关于我们",children: [{
          path: "about",name: "公司简介", other: {key: "content"}, children: []
        },{
          path: "about",name: "发展历程", other: {key: "development"}, children: []
        },{
          path: "about",name: "投资伙伴", other: {key: "partner"}, children: []
        },{
          path: "zhao",name: "加入我们", other: {}, children: []
        }]},
      ],
    },
    // 底部内容
    foot: {
      // 导航
      navs: [
        {path: "product",name: "产品技术", other: {key: "MimicPro 2"},children: [{path: "productList",name: "EDA", other: {key: "EDA"}},{path: "productList",name: "IP", other: {key: "IP"}}]},
        {path: "service",name: "支持与服务",children: [{path: "service",name: "线上技术支持", other: {key: 'zhichi'}},{path: "service",name: "文档中心", other: {key: 'ziliao'}},{path: "service",name: "技术视频", other: {key: 'videos'}}]},
        {path: "news",name: "新闻中心",children: [{path: "news",name: "公司动态"},{path: "news",name: "媒体关注"}]},
        {path: "about",name: "关于我们",children: [{path: "about",name: "公司简介", other: {key: "content"}},{path: "about",name: "发展历程", other: {key: "development"}},{path: "zhao",name: "加入我们"}]},
      ],
      contactTitle: "联系我们",
      contactPhone: "021-58768929",
      emails: ["sales@corepilot-semi.com", "contact@corepilot-semi.com"],
      showFollow: true,
      followTitle: "关注我们",
      copyright: "Copyright @上海启芯领航半导体有限公司 | 沪ICP备2025153123号 | 沪公网安备31010502007566号",
      copyrightMobile: ["Copyright @上海启芯领航半导体有限公司", "沪ICP备2025153123号", "沪公网安备31010502007566号"],
      legalNotice: "法律声明",
      privacyPolicy: "隐私政策",
      bottomCombined: false,
    },
    index: {
      productTitle: "产品技术",
      edaDesc: "数字芯片验证EDA",
      ipDesc: "高速接口控制器 IP",
      newsTitle: "新闻中心",
      aboutTitle: "公司简介",
      stats: [
        { num: "2015", suffix: "", label: "公司成立" },
        { num: "1.53", suffix: "亿", label: "注册资本" },
        { num: "75%", suffix: "+", label: "研发占比" },
        { num: "5", suffix: "", label: "研发中心" },
      ],
      clientsTitle: "客户与合作伙伴",
      supportTitle: "技术支持",
      supportDesc: "欢迎加入启芯领航支持与服务社区",
      resourcesTitle: "技术资料",
      resourcesDesc: "我们将竭诚为您提供精准高效的服务",
    },
    form: {
      consultTitle: "立即咨询",
      consultDesc: "请留下您的联系方式与问题，我们将尽快与您联系，或直接发送至",
      submit: "提交",
      name: "姓名：",
      company: "公司：",
      jobTitle: "职位：",
      email: "企业邮箱：",
      phone: "手机号码：",
      inquiry: "问题咨询：",
      namePlaceholder: "请输入您的姓名",
      companyPlaceholder: "请输入您的公司名称",
      jobTitlePlaceholder: "请输入您的职位",
      emailPlaceholder: "请输入您的企业邮箱",
      phonePlaceholder: "请输入您的手机号码",
      inquiryPlaceholder: "请输入您要咨询的问题",
      required: "该选项为必填项",
      phoneInvalid: "请输入正确的手机号",
      emailInvalid: "请输入正确的邮箱地址",
      emailForbidden: "不支持 QQ / 163 / 126 邮箱",
      success: "操作成功",
      downloadTitle: "下载申请",
      downloadDesc: "请留下您的联系方式，我们将尽快与您联系",
      downloadReason: "下载事由：",
      downloadReasonPlaceholder: "请您告知下载这份资料的原因，以帮我们更好地了解您的需求和提供服务，谢谢！",
      modalTitle: "信息填写",
      tipTitle: "提示",
      tipContent: "感谢垂询，我们将尽快审核您的信息，通过后将把资料发送到您提供的邮箱。谢谢！",
      okText: "确定",
      cancelText: "取消",
    },
    product: {
      overview: "产品概述",
      specifications: "产品参数",
      advantages: "产品优势",
      model: "产品型号",
      featureList: "功能列表",
      scenarios: "应用场景",
      download: "立即下载",
      items: {
        'MimicPro 2': {
          shuju: [
            { num: '60%', name: '9M逻辑单元' },
            { num: '63%', name: '48M等效门数' },
            { num: '33%', name: '3,840 DSP Slice' },
            { num: '150%', name: '224Mb内存' },
          ],
        },
        'MimicPro 3': {
          shuju: [
            { num: '107%', name: '18.5M逻辑单元' },
            { num: '107%', name: '99M等效门数' },
            { num: '79%', name: '6,864 DSP Slice' },
            { num: '398%', name: '1,116Mb内存' },
          ],
        },
        USB: {
          gongneng1: `•   支持 USB 3.2/3.1/3.0/2.0速率 (20G/10G/5G/480M bps)<br>
•   兼容标准驱动<br>
•   支持 PIPE v4.3 协议, 支持不同数据位宽<br>
•   支持内嵌 DMA<br>
•   支持 AXI3/AXI4 接口，支持不同数据位宽<br>
•   支持自动链路极性检测和反转<br>
•   USB 3.x支持 U1/U2/U3 低功耗状态<br>
•   USB 2.0支持 L1/L2 低功耗状态<br>
•   USB 2.0支持硬件 LPM 和 BESL<br>
•   支持 MSI/MSI-X 以及 Legacy 中断<br>
•   支持 Debug Capability<br>
•    支持 bulk streaming传输`,
          gongneng2: `•   支持 UTMI+/ULPI 接口，支持不同数据位宽<br>
•   支持 AXI/AHB/APB 等不同类型寄存器访问接口<br>
•   中断源数目可配置<br>
•   Slot 数目可配<br>
•   IN/OUT endpoint 数目可配置<br>
•   可配置的数据接收和传输缓冲区大小 <br>
•   不同带宽，延时组合可配置<br>
•   DMA 支持 Scatter-and-Gather 内存访问<br>
•   支持描述符和数据预取功能，提示传输效率<br>
•   可配置的端口数目<br>
•   支持 control/bulk/interrupt/Isochronous 所有种类数据传输`,
          changjings: ['消费类电子', '存储设备', '视频/图像处理器', '汽车电子'],
        },
        PCle: {
          gongneng1: `•   支持 PCIe Gen1/2/3/4/5速率 (2.5G/5G/8G/16G/32G bps), 支持最大速率配置为 Gen3-Gen5 速率<br>
•   支持 x1, x2, x4, x8 和 x16 条链路<br>
•   支持 PIPE v5.2 协议, 支持original PIPE模式和SerDes接口模式<br>
•   单条链路PIPE接口支持 16-bit, 32-bit 和 64-bit 数据位宽<br>
•   支持 AXI3/AXI4 和 自定义用户接口<br>
•   支持自动链路极性检测和反转<br>
•   支持 256bit, 512bit 和 1024bit 内部数据位宽<br>
•   原子操作<br>
•   L1 低功耗状态<br>
•   数据链路包前缀（prefix）<br>
•   单端 I/O 虚拟化 (SR-IOV) 支持最大4096个虚拟功能（VF）<br>
•   替代路由ID 转译(ARI)`,
          gongneng2: `•   地址翻译服务(ATS)<br>
•   数据链路包处理提示(TPH)<br>
•   进程地址空间 ID (PASID)<br>
•   有源状态电源管理(ASPM)<br>
•   高级错误报告(AER)<br>
•   端对端循环冗余校验 (ECRC) <br>
•   精确时间测量(PTM)<br>
•   访问控制服务(ACS)<br>
•   轻量级通知(LN)<br>
•   可配置的接收和传输/重试缓冲区大小<br>
•   可配置的完成超时<br>
•   可配置最大传输包长<br>
•   支持配置空间后面访问`,
          changjings: ['高性能计算', '存储设备', '人工智能', '图像处理'],
        },
        RDMA: {
          gongneng1: `•   支持 RoCEv2 IPV4 RDMA<br>
•   支持 RC（Reliable connection）<br>
•   支持 MR（Memory Region）<br>
•   支持流量控制算法：DCQCN和UEC RCCC（基于信用机制），可定制CC算法<br>
•   支持选择性重传<br>
•   支持多路径（Mutipath）<br>
•   支持 GDR Flush功能 `,
          gongneng2: `•   支持 GDR（GPU Direct RDMA） <br>
•   支持 RDMA mode：send/receive、write/write with imm<br>
•   支持 PFC <br>
•   支持 QP/CQ/EQ<br>
•   支持 CQ中断或轮询<br>
•   支持 RDMA inline <br>
•   支持与CX7互通`,
          changjings: ['HPC', 'AI', 'GPU', 'DPU'],
        },
      },
    },
    service: {
      technicalSupport: "线上技术支持",
      supportDesc: "启芯领航（Corepilot）的专业技术团队提供及时、高效的本地化服务支持: 包括产品文档、技术视频及有关产品规格、使用及解决方案咨询。您可就近联系当地的应用工程师咨询相关技术支持服务。",
      hotlineLabel: "客服电话：",
      hotline: "021-5876 8929",
      emailLabel: "客服邮箱：",
      email: "service@corepilot-semi.com",
      documentCenter: "文档中心",
      edaSeries: "数字芯片验证EDA产品系列",
      ipSeries: "高速接口控制器 IP产品系列",
      technicalVideos: "技术视频",
    },
    news: {
      title: "新闻中心",
      totalText: "共 {total} 条",
      newsCenter: "新闻中心",
      newsArticle: "新闻稿",
    },
    about: {
      profile: "公司简介",
      developmentHistory: "发展历程",
      investmentPartners: "投资伙伴",
      joinUs: "加入我们",
      stats: [
        { num: "2015", suffix: "", label: "公司成立" },
        { num: "1.53", suffix: "亿", label: "注册资本" },
        { num: "75%", suffix: "+", label: "研发占比" },
        { num: "5", suffix: "", label: "研发中心" },
      ],
    },
    zhao: {
      whyTitle: "为什么选择我们？",
      hotPositions: "热招岗位",
      jobDescription: "岗位描述：",
      jobRequirements: "任职要求：",
      tips: "如您对以上职位感兴趣，欢迎将简历发送至 <span>hr@corepilot-semi.com</span> <br />或通过我们的Boss直聘主页查看最新职位，收到简历后我们会尽快与您联系，期待您的加入！",
    },
  },
  2: {
    // 顶部内容
    top: {
      // 导航
      navs: [
        {path: "index",name: "Home"},
        {path: "product",name: "Products", other: {key: "MimicPro 2"},children: [
          {path: "product",name: "EDA", other: {key: "MimicPro 2"}, children: [
            {path: "product",name: "MimicTurbo GT", other: {key: "MimicTurbo GT"}},
            {path: "product",name: "MimicPro 2", other: {key: "MimicPro 2"}},
            {path: "product",name: "MimicPro 3", other: {key: "MimicPro 3"}},
          ]},
          {path: "product",name: "IP", other: {key: "USB"}, children: [
            {path: "product",name: "USB Controller", other: {key: "USB"}},
            {path: "product",name: "PCIe Controller", other: {key: "PCle"}},
            {path: "product",name: "RDMA", other: {key: "RDMA"}}
          ]}
        ]},
        {path: "service",name: "Support",children: []},
        {path: "news",name: "Media",children: []},
        {path: "about",name: "Company",children: [{
          path: "about",name: "About Us", other: {key: "content"}, children: []
        },{
          path: "about",name: "Development History", other: {key: "development"}, children: []
        },{
          path: "about",name: "Investor", other: {key: "partner"}, children: []
        },{
          path: "zhao",name: "Careers", other: {}, children: []
        }]},
      ],
    },
    // 底部内容
    foot: {
      // 导航
      navs: [
        {path: "product",name: "Products", other: {key: "MimicPro 2"},children: [{path: "productList",name: "EDA", other: {key: "EDA"}},{path: "productList",name: "IP", other: {key: "IP"}}]},
        {path: "service",name: "Support",children: [{path: "service",name: "Online Technical Support", other: {key: 'zhichi'}},{path: "service",name: "Document Center", other: {key: 'ziliao'}},{path: "service",name: "Videos", other: {key: 'videos'}}]},
        {path: "news",name: "Media",children: []},
        {path: "about",name: "Company",children: [{path: "about",name: "About Us", other: {key: "content"}},{path: "about",name: "Investors", other: {key: "partner"}},{path: "zhao",name: "Careers"}]},
      ],
      contactTitle: "Contact Us",
      contactPhone: "+86-21-58768929",
      emails: ["sales@corepilot-semi.com", "contact@corepilot-semi.com"],
      showFollow: false,
      copyright: "Copyright @ Shanghai Corepilot Semiconductor Co.Ltd | 沪ICP备2025153123号 | 沪公网安备31010502007566号",
      copyrightMobile: ["Copyright @ Shanghai Corepilot Semiconductor Co.Ltd", "沪ICP备2025153123号", "沪公网安备31010502007566号"],
      legalNotice: "Legal Statement",
      privacyPolicy: "Privacy Policy",
      bottomCombined: true,
    },
    index: {
      productTitle: "Products",
      edaDesc: "Digital Chip Verification",
      ipDesc: "High-Speed Interface Controller",
      newsTitle: "What's New",
      aboutTitle: "About Corepilot",
      stats: [
        { num: "2015", suffix: "", label: "Founded" },
        { num: "153M", suffix: "CNY", label: "Registered Capital" },
        { num: "75%", suffix: "+", label: "R&D Staff" },
        { num: "5", suffix: "", label: "R&D Centers" },
      ],
      content: `<p>Founded in November 2015 in Zhangjiang Hi-Tech Park, Shanghai, Shanghai Corepilot Semiconductor Co., Ltd. has a registered capital of RMB 153 million. It is a leading domestic enterprise dedicated to the R&amp;D of digital chip verification EDA tools and high-speed interface controller IPs.</p><p>The company's MimicPro® integrated hardware emulation and prototyping platform has been deployed by numerous leading semiconductor enterprises and research institutes worldwide and widely applied to CPUs, GPUs, AI, AIoT, communication chips and other core fields.</p><p>USB Controller IP: Supports full protocol coverage from USB 2.0 to USB 3.2 with USB-IF certification. It features small die area, low power consumption and high configurability and widely used in consumer electronics, servers, industrial control and other applications.</p><p>PCIe Gen5 EP Controller IP: Backward compatible with Gen4/3/2/1; supports the full Gen5 speed and up to ×16 lanes with comprehensive protocol features; widely adopted in AI, HPC, storage, video imaging, automotive electronics and other sectors.</p><p>Corepilot has assembled a global team of professionals. Core members are from leading EDA and semiconductor companies including Synopsys, Cadence and Marvell, with R&amp;D staff accounting for over 75% of the total workforce.</p><p>Committed to independent innovation and customer-centric services, Corepilot continues to drive the advancement of the domestic EDA industry. It has been recognized with multiple authoritative qualifications, including National High-Tech Enterprise, Specialized, Sophisticated, Unique and Novel Small and Medium Enterprise, and R&amp;D Institution of Pudong New Area.</p>`,
      clientsTitle: "Clients and Partners",
      supportTitle: "Support",
      supportDesc: "Welcome to Corepilot Support and Service Community",
      resourcesTitle: "Resources",
      resourcesDesc: "Delivering Precise and Efficient Services to you",
    },
    form: {
      consultTitle: "Get In Touch with Our Sales Team",
      consultDesc: "Required Fields *",
      submit: "Submit",
      name: "Name:",
      company: "Company:",
      jobTitle: "Job Title:",
      email: "Business Email:",
      phone: "Phone:",
      inquiry: "Your Inquiry:",
      namePlaceholder: "Please enter your name",
      companyPlaceholder: "Please enter your company name",
      jobTitlePlaceholder: "Please enter your job title",
      emailPlaceholder: "Please enter your business email",
      phonePlaceholder: "Please enter your phone number",
      inquiryPlaceholder: "Please enter your inquiry",
      required: "This field is required",
      phoneInvalid: "Please enter a valid phone number",
      emailInvalid: "Please enter a valid email address",
      emailForbidden: "QQ / 163 / 126 email addresses are not supported",
      success: "Submitted successfully",
      downloadTitle: "Download Request",
      downloadDesc: "Required Fields *",
      downloadReason: "Reason for Download:",
      downloadReasonPlaceholder: "Please tell us why you are downloading this document. It will help us understand your needs and provide better service. Thank you!",
      modalTitle: "Download Request",
      tipTitle: "Notice",
      tipContent: "Thank you for your inquiry. We will review your information as soon as possible and send the materials to the email address you provided once approved. Thank you!",
      okText: "OK",
      cancelText: "Cancel",
    },
    product: {
      overview: "Product Overview",
      specifications: "Product Specifications",
      advantages: "Product Advantages",
      model: "Product Model",
      featureList: "Feature List",
      scenarios: "Application Scenarios",
      download: "Download",
      items: {
        'MimicPro 2': {
          shuju: [
            { num: '60%', name: '9M Logic Cells' },
            { num: '63%', name: '48M Equivalent Gates' },
            { num: '33%', name: '3,840 DSP Slices' },
            { num: '150%', name: '224Mb memory' },
          ],
        },
        'MimicPro 3': {
          shuju: [
            { num: '107%', name: '18.5M Logic Cells' },
            { num: '107%', name: '99M Equivalent Gates' },
            { num: '79%', name: '6,864 DSP Slices' },
            { num: '398%', name: '1,116Mb Memory' },
          ],
        },
        USB: {
          gongneng1: `• Supports USB 3.2/3.1/3.0/2.0 speeds (20G/10G/5G/480M bps)<br>
• Compatible with standard drivers<br>
• Supports PIPE v4.3 protocol and various data bus widths<br>
• Supports embedded DMA<br>
• Supports AXI3/AXI4 interfaces with configurable data bus widths<br>
• Supports automatic link polarity detection and inversion<br>
• USB 3.x supports U1/U2/U3 low-power states<br>
• USB 2.0 supports L1/L2 low-power states<br>
• USB 2.0 supports hardware LPM and BESL<br>
• Supports MSI/MSI-X and Legacy interrupts<br>
• Supports Debug Capability<br>
• Supports bulk streaming transfer`,
          gongneng2: `• Supports UTMI+/ULPI interfaces with various data bus widths<br>
• Supports register access interfaces including AXI/AHB/APB<br>
• Configurable number of interrupt sources<br>
• Configurable number of slots<br>
• Configurable number of IN/OUT endpoints<br>
• Configurable RX and TX buffer sizes<br>
• Configurable bandwidth and latency combinations<br>
• DMA supports Scatter-and-Gather memory access<br>
• Supports descriptor and data prefetching to improve transfer efficiency<br>
• Configurable number of ports<br>
• Supports all transfer types: control, bulk, interrupt, and isochronous`,
          changjings: ['Consumer Electronics', 'Storage Devices', 'Video/Image Processors', 'Automotive Electronics'],
        },
        PCle: {
          gongneng1: `• Supports PCIe Gen1/2/3/4/5 speeds (2.5G/5G/8G/16G/32G bps), with maximum speed configurable as Gen3–Gen5<br>
• Supports x1, x2, x4, x8, and x16 lanes<br>
• Supports PIPE v5.2 protocol, including original PIPE mode and SerDes interface mode<br>
• 16-bit, 32-bit, and 64-bit data bus widths supported per lane on the PIPE interface<br>
• Supports AXI3/AXI4 and custom user interfaces<br>
• Supports automatic link polarity detection and inversion<br>
• Supports 256-bit, 512-bit, and 1024-bit internal data path widths<br>
• Atomic Operations<br>
• L1 low-power state<br>
• Data Link Control Packet Prefix<br>
• Single-Root I/O Virtualization (SR-IOV) supporting up to 4096 Virtual Functions (VFs)<br>
• Alternative Routing-ID Interpretation (ARI)`,
          gongneng2: `• Address Translation Services (ATS)<br>
• TLP Processing Hints (TPH)<br>
• Process Address Space ID (PASID)<br>
• Active State Power Management (ASPM)<br>
• Advanced Error Reporting (AER)<br>
• End-to-End Cyclic Redundancy Check (ECRC)<br>
• Precision Time Measurement (PTM)<br>
• Access Control Services (ACS)<br>
• Lightweight Notification (LN)<br>
• Configurable RX and TX/replay buffer sizes<br>
• Configurable completion timeout<br>
• Configurable Maximum Payload Size<br>
• Supports Configuration Space Backdoor Access`,
          changjings: ['High Performance Computing', 'Storage Devices', 'Artificial Intelligence', 'Image Processing'],
        },
        RDMA: {
          gongneng1: `• Supports RoCEv2 IPv4 RDMA<br>
• Supports RC (Reliable Connection)<br>
• Supports MR (Memory Region)<br>
• Supports congestion control algorithms: DCQCN and UEC RCCC (credit-based), with customizable CC algorithms<br>
• Supports selective retransmission<br>
• Supports Multipath<br>
• Supports GDR Flush function`,
          gongneng2: `• Supports GDR (GPU Direct RDMA)<br>
• Supports RDMA modes: send/receive, write/write with imm<br>
• Supports PFC<br>
• Supports QP/CQ/EQ<br>
• Supports CQ interrupt or polling mode<br>
• Supports RDMA inline<br>
• Supports interoperability with CX7`,
          changjings: ['HPC', 'AI', 'GPU', 'DPU'],
        },
      },
    },
    service: {
      technicalSupport: "Technical Support",
      supportDesc: "Corepilot's professional technical team provides timely and efficient localized support services, including product documentation, technical videos, and consulting on product specifications, usage, and solutions. You may contact your local applications engineer for relevant technical support services.",
      hotlineLabel: "Service Hotline: ",
      hotline: "+86-21-5876 8929",
      emailLabel: "Service Email: ",
      email: "service@corepilot-semi.com",
      documentCenter: "Document Center",
      edaSeries: "Digital Chip Verification EDA Product Series",
      ipSeries: "High-Speed Interface Controller IP Product Series",
      technicalVideos: "Technical Videos",
    },
    news: {
      title: "What's New",
      totalText: "Total of {total} items",
      newsCenter: "What's New",
      newsArticle: "Press Release",
    },
    about: {
      profile: "Company Profile",
      developmentHistory: "Development History",
      investmentPartners: "Investment Partners",
      joinUs: "Join Us",
      stats: [
        { num: "2015", suffix: "", label: "Founded" },
        { num: "153M", suffix: "CNY", label: "Registered Capital" },
        { num: "75%", suffix: "+", label: "R&D Staff" },
        { num: "5", suffix: "", label: "R&D Centers" },
      ],
      content: `<p>Shanghai Corepilot Semiconductor Co., Ltd. was incorporated in November 2015 in the Zhangjiang Hi-Tech Park, Shanghai, with a registered capital of 153 million yuan. It is a leading domestic enterprise specializing in digital chip verification EDA tools and high-speed interface controller IP development.</p><p>The company's MimicPro® integrated hardware emulation and prototyping verification tool has been adopted by numerous leading semiconductor companies and research institutes at home and abroad, and is widely used in CPU, GPU, AI, AIoT, communication chips and other fields.</p><p>USB Controller IP: Supports full protocol coverage from USB 2.0 to USB 3.2 and is certified by USB-IF. It features small area, low power consumption and flexible configuration, and is widely applied in consumer electronics, servers, industrial control and other fields.</p><p>PCIe Gen5 EP Controller IP: Backward compatible with Gen4/3/2/1; supports up to Gen5 speed and x16 lanes with rich protocol features; widely used in AI, HPC, storage, video imaging, automotive electronics and other fields.</p><p>The company recruits professional talents worldwide. Its core team comes from leading EDA and semiconductor enterprises such as Synopsys, Cadence and Marvell, with R&amp;D personnel accounting for over 75%.</p><p>Adhering to independent innovation and customer service, Corepilot promotes the progress of the domestic EDA industry. It has been awarded various honors and qualifications including National High-Tech Enterprise, Specialized, Sophisticated, Unique and New Small and Medium-sized Enterprise, and Pudong New Area R&amp;D Institution.</p>`,
    },
    zhao: {
      whyTitle: "Why Corepilot?",
      hotPositions: "Hot Positions",
      jobDescription: "Job Description",
      jobRequirements: "Job Requirements",
      tips: "If you are interested in the above positions, please send your resume to <span>hr@corepilot-semi.com</span>.<br />You may also view the latest job openings on our Boss Zhipin homepage. We will contact you as soon as we receive your resume. We look forward to having you on board!",
    },
  }
}

export default language;


// WEBPACK FOOTER //
// ./src/utils/language.js